import { createContext, useContext } from 'react';

export const ProductContext = createContext();

export const useProductContext = () => {
	return useContext(ProductContext);
};
